export type BwjPillSize = 10 | 12 | 14 | 16 | 18 | 20;

export namespace BwjPillSizes {
    export const xsmall = 10;
    export const small = 12;
    export const regular = 14;
    export const large = 16;
    export const xlarge = 18;
    export const xxlarge = 20;
}